/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MassDeleteFichierRequestDto
 */
export interface MassDeleteFichierRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof MassDeleteFichierRequestDto
     */
    idsfichier?: Array<number> | null;
}

/**
 * Check if a given object implements the MassDeleteFichierRequestDto interface.
 */
export function instanceOfMassDeleteFichierRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MassDeleteFichierRequestDtoFromJSON(json: any): MassDeleteFichierRequestDto {
    return MassDeleteFichierRequestDtoFromJSONTyped(json, false);
}

export function MassDeleteFichierRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MassDeleteFichierRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsfichier': !exists(json, 'idsfichier') ? undefined : json['idsfichier'],
    };
}

export function MassDeleteFichierRequestDtoToJSON(value?: MassDeleteFichierRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsfichier': value.idsfichier,
    };
}

